import React, { useEffect } from "react";
import { FloatingPortal } from "@floating-ui/react";

import "./style.scss";

export default function PopupComponent({
  isOpen,
  setIsOpen,
  children,
  refs,
  floatingStyles,
  getFloatingProps,
}) {
  useEffect(() => {
    if (isOpen) {
      const timeoutId = setTimeout(() => {
        setIsOpen(false);
      }, 3000);

      return () => {
        clearTimeout(timeoutId);
      };
    }
  }, [isOpen, setIsOpen]);

  return (
    <div className="popup-component">
      <FloatingPortal>
        {isOpen && (
          <div
            className="popup-content-inner"
            ref={refs.setFloating}
            style={floatingStyles}
            {...getFloatingProps()}
          >
            {children}
          </div>
        )}
      </FloatingPortal>
    </div>
  );
}
